var RemindOverviewComponent = (function () {
    function RemindOverviewComponent() {
    }
    return RemindOverviewComponent;
}());
export { RemindOverviewComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/remind-overview/remind-overview.component.ts.pre-build-optimizer.js